import React from 'react';
import WorkforceOnboardingSvg from './assets/WorkforceOnboarding.svg';
import { ImageProps } from './interface';

export function WorkforceOnboardingImage(props: ImageProps) {
  return <WorkforceOnboardingSvg {...props} />;
}
